import React, { useState } from 'react'
import { Box } from '../../layout/Box'
import Input from '../../layout/Input'
import { SubmitButton } from '../../../styles/components/buttons'
import { Loading } from '../../data/Loading'
import { ErrorMessage } from '../../data/ErrorMessage'
import { forgotPassword } from '../../../api/auth'
import { Typography } from '../../layout/Typography'
import { Link } from '../../layout/Link'
import { RouteType } from '../../../types/routes'
import { getSalonGuidFromUrlParams } from '../../../utils/urlParams'

export const ForgotPasswordComponent: React.FC = () => {
  const [email, setEmail] = useState<string>('')

  const [loading, setLoading] = useState<boolean>(false)
  const [errors, setErrors] = useState<string>('')

  const [submittedMessage, setSubmittedMessage] = useState<string>('')

  const resetPassword = async () => {
    setLoading(true)
    const response = await forgotPassword({
      email,
      salonGuid: getSalonGuidFromUrlParams()
    })

    if (response === null) {
      setErrors('No server response')
      setLoading(false)
      return
    }

    if (response.status === 'Success') {
      setSubmittedMessage(response.message)
    } else if (response.status === 'Unauthorized') {
      setErrors(response.message)
    }

    setLoading(false)
  }

  return (
    <Box>
      {loading && <Loading />}
      {submittedMessage ? (
        <>
          <Typography variant="body1">{submittedMessage}</Typography>
          <Link to={RouteType.Home}>
            <SubmitButton>Home</SubmitButton>
          </Link>
        </>
      ) : (
        <>
          <Input label="Email" name="email" onChange={setEmail} />
          {errors && <ErrorMessage>{errors}</ErrorMessage>}

          <SubmitButton onClick={resetPassword}>Passwort zurücksetzen</SubmitButton>
        </>
      )}
    </Box>
  )
}
